import { Injectable } from '@angular/core';

import { grpcOperator } from '@lyra/app/core/api/grpc/pipe-operators/grpc';
import { MainApi } from '@mark/web-contracts';
import { from } from 'rxjs';

import { GRpcRequestType } from '../grpc-class.type';
import { GrpcCommonService } from './common.service';

export type ICreateSimpleOrder = GRpcRequestType<MainApi.OrderV2GrpcContractClient['CreateSimpleOrder']>;

@Injectable()
export class OrderV2GrpcContractService extends GrpcCommonService<MainApi.OrderV2GrpcContractClient> {
  constructor(protected _GrpcContract: MainApi.OrderV2GrpcContractClient) {
    super();
  }

  createSimpleOrder(request: ICreateSimpleOrder) {
    return from(
      this._GrpcContract.CreateSimpleOrder(
        new MainApi.CreateUserOrderWpcRequest(MainApi.CreateUserOrderWpcRequest.fromObject(request)),
        this.getMetadata(),
      ),
    ).pipe(grpcOperator());
  }
}
